import type { UseFontHook } from './Font.types';

export * from './Font';

export const useFonts: UseFontHook = () => {
  return [false, null];
};
